<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  created() {
    // console.log('process', process.env.VUE_APP_BASE_API);
  }
}
</script>
<style lang="scss">
#app {
  font-family: PingFangSC-Regular, PingFang SC;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: white;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
